import { render, staticRenderFns } from "./DTSharedModal.vue?vue&type=template&id=7b2903b0&"
import script from "./DTSharedModal.vue?vue&type=script&lang=js&"
export * from "./DTSharedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports